import type { KissType } from '../lib/api';

export interface KissTypeInfo {
  id: KissType;
  emoji: string;
  name: string;
  description: string;
  /** Cheapest available price for this type, used as "from ⭐ X" label */
  fromStars: number;
}

export const KISS_TYPES: KissTypeInfo[] = [
  { id: 'cheek',  emoji: '😘', name: 'Cheek',  description: 'Sweet & gentle',         fromStars: 1 },
  { id: 'lips',   emoji: '💋', name: 'Lips',   description: 'Romantic & tender',      fromStars: 1 },
  { id: 'french', emoji: '🔥', name: 'French', description: 'Passionate & intense',   fromStars: 1 },
];

/**
 * Pricing matrix mirrored from api/src/lib/pricing.ts. Keeping a copy on the
 * frontend lets the duration picker show the price next to each pill without
 * a round-trip; the Worker remains the source of truth (re-validates on
 * pre_checkout_query).
 */
export const PRICING: Record<KissType, Partial<Record<number, number>>> = {
  cheek:  { 6: 1, 10: 1 },
  lips:   { 6: 1, 10: 1, 15: 1 },
  french: {        10: 1, 15: 1, 20: 1 },
};

export const DURATIONS = [6, 10, 15, 20] as const;

export function getPrice(type: KissType, duration: number): number | null {
  return PRICING[type][duration] ?? null;
}
